(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('securityEventsLinkGenerator', ["base64", "routeHelper", function (base64, routeHelper) {
        function createPath(params) {
            var filters = [];
            _(params).each(function (values, type) {
                if (type !== 'resolution') {
                    _(_(values).isArray() ? values : [values]).each(function (value) {
                        filters.push({
                            type: type,
                            id: value
                        });
                    });
                }
            });
            var toEncode = { filters: filters };
            if (params.resolution) {
                toEncode.resolution = params.resolution;
            }
            var qs = { filters: base64.encode(JSON.stringify(toEncode)) };
            if (params.eventId) {
                qs.eventId = params.eventId;
            }
            return routeHelper.getPath('security-events', {}, qs);
        }
        return {
            createHref: function (params) {
                return routeHelper.pathToHref(createPath(params));
            },
            createPath: function (params) {
                return createPath(params);
            }
        };
    }]);
}());